import { useFormState, useWatch } from 'react-hook-form';
import { requiredOk } from '../../../utils';

export const useOfficeProfile = (control) => {
  const watchedValues = useWatch({
    control,
    name: [
      'officeName',
      'website',
      'dentistFirstName',
      'dentistLastName',
      'additionalContactFirstName',
      'additionalContactLastName',
      'officeType',
      'selectedSpecialty',
    ],
  });

  const { dirtyFields } = useFormState({ control });

  const formValues = {
    officeName: watchedValues[0],
    website: watchedValues[1],
    dentistFirstName: watchedValues[2],
    dentistLastName: watchedValues[3],
    additionalContactFirstName: watchedValues[4],
    additionalContactLastName: watchedValues[5],
    officeType: watchedValues[6],
    selectedSpecialty: watchedValues[7],
  };

  const isOfficeNameValid = !!formValues.officeName?.trim();
  const isDentistFirstNameValid = !!formValues.dentistFirstName?.trim();
  const isDentistLastNameValid = !!formValues.dentistLastName?.trim();
  const isAdditionalContactFirstNameValid =
    !formValues.additionalContactFirstName || !!formValues.additionalContactFirstName?.trim();
  const isAdditionalContactLastNameValid =
    !formValues.additionalContactLastName || !!formValues.additionalContactLastName?.trim();
  const isOfficeTypeValid = !!formValues.officeType?.trim();
  const isSelectedSpecialtyValid = !!formValues.selectedSpecialty?.trim();

  const isValid =
    isOfficeNameValid &&
    isDentistFirstNameValid &&
    isDentistLastNameValid &&
    isAdditionalContactFirstNameValid &&
    isAdditionalContactLastNameValid &&
    isOfficeTypeValid &&
    isSelectedSpecialtyValid;

  const canSave =
    requiredOk(dirtyFields.officeName, isOfficeNameValid) &&
    requiredOk(dirtyFields.dentistFirstName, isDentistFirstNameValid) &&
    requiredOk(dirtyFields.dentistLastName, isDentistLastNameValid) &&
    isAdditionalContactFirstNameValid &&
    isAdditionalContactLastNameValid &&
    requiredOk(dirtyFields.officeType, isOfficeTypeValid) &&
    requiredOk(dirtyFields.selectedSpecialty, isSelectedSpecialtyValid);

  return {
    formValues,
    isValid,
    canSave,
  };
};
